import axios from 'axios';
import { registerMaintenanceInterceptor } from '../common/maintenance';
import Config from '../config';

const apiClient = axios.create({
  baseURL: Config.ApiEndpoint,
  withCredentials: true,
});

export const externalClient = axios.create({
  withCredentials: false,
});

// A 491 has to show the maintenance page no matter which client made the call.
// The default axios instance is covered as well because the mobx-rest adapters
// (form builder, SMStore) issue their requests through it.
registerMaintenanceInterceptor(apiClient);
registerMaintenanceInterceptor(externalClient);
registerMaintenanceInterceptor(axios);

export default apiClient;
